export function getPlace (search) {
    return search.place || {}
}

export function getLatitude (search) {
    return getPlace(search).latitude
}

export function getLongitude (search) {
    return getPlace(search).longitude
}
